import toast from "react-hot-toast";
import { TFunction } from "i18next";
import { Score } from "@/pages/deals/types";
import { getScoreKey, ScoreConfig } from "@/pages/deals/scoreConfig";
import QuestionnaireScoreToastContent from "./components/QuestionnaireScoreToastContent";

interface ShowQuestionnaireScoreToastParams {
  previousScore: Score | null;
  newScore: Score | null;
  questionnaireName: string;
  questionnaireId: string;
  kpiValue: string;
  hideErrorToast?: boolean;
  t: TFunction;
}

export const showQuestionnaireScoreToast = ({
  previousScore,
  newScore,
  questionnaireName,
  questionnaireId,
  kpiValue,
  hideErrorToast = false,
  t
}: ShowQuestionnaireScoreToastParams): void => {
  const previousScoreKey = getScoreKey(previousScore?.scoreText || "");
  const newScoreKey = getScoreKey(newScore?.scoreText || "");
  if (
    previousScoreKey !== ScoreConfig.FAILED &&
    newScoreKey === ScoreConfig.FAILED &&
    !hideErrorToast
  ) {
    const toastId = `failed-${questionnaireId}`;
    toast.dismiss(toastId);
    toast.error(
      () => (
        <QuestionnaireScoreToastContent
          questionnaireName={questionnaireName}
          newScore={newScore}
          newScoreKey={newScoreKey}
          kpiValue={kpiValue}
          t={t}
        />
      ),
      {
        icon: null
      }
    );
  }
  if (
    previousScoreKey !== ScoreConfig.PASS &&
    newScoreKey === ScoreConfig.PASS &&
    !hideErrorToast
  ) {
    const toastId = `passed-${questionnaireId}`;
    toast.dismiss(toastId);
    toast.success(
      () => (
        <QuestionnaireScoreToastContent
          questionnaireName={questionnaireName}
          newScore={newScore}
          newScoreKey={newScoreKey}
          kpiValue={kpiValue}
          t={t}
        />
      ),
      {
        icon: null
      }
    );
  }
};
